export default "__VITE_ASSET__fZ1soGNO__"